export const card = {
    namespaced: true,
    state: {
        dataTable: []
    },
    getters: {
        getDataTable: state => state.dataTable
    },
    mutations: {
        ADD_DATA_TO_DATATABLE(state, newData) { 
            if(state.dataTable[newData.id]) {
                state.dataTable[newData.id].push(newData.dataTable)
            } else {
                state.dataTable[newData.id] = []
                state.dataTable[newData.id].push(newData.dataTable)
            }
        },
        CLEAR_GET_DATA_TABLE(state) {
            state.dataTable = {}
          }
    },
    actions: {
        addDataToDataTable({ commit }, newData) {
          commit('ADD_DATA_TO_DATATABLE', newData)
        },
        clearDataTable({ commit }) {
            commit('CLEAR_GET_DATA_TABLE')
          },
    }
}